export default "__VITE_ASSET__Dw3Rs0RL__"